/**
 * fileStamp.js — the YYYYMMDD suffix used on exported filenames.
 *
 * Matches the convention Jadual Awalan (Kadar Respon) already uses, e.g.
 * `Ringkasan_Kadar_Respon_Isi_Rumah_Pusingan1_20260618.xlsx`.
 *
 * Built from LOCAL date parts on purpose. `toISOString().slice(0,10)` is UTC,
 * so in Malaysia (UTC+8) it reports the previous day for anything downloaded
 * between midnight and 8am — the file would be stamped with yesterday's date.
 *
 * Mirrors src/lib/fileStamp.js in the API. Several exports are named on both
 * sides (the server sets Content-Disposition, the browser sets a.download for
 * blob downloads), so the two must agree.
 */
export function fileStamp(date = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
}
